import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { TheoryPractice } from './components/TheoryPractice';
import { Volumes } from './components/Volumes';
import { FitCheck } from './components/FitCheck';
import { Bonuses } from './components/Bonuses';
import { StickyBuyBar } from './components/StickyBuyBar';
import { LaunchUrgency } from './components/LaunchUrgency';
import { Offer } from './components/Offer';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-night pb-[68px] font-sans text-cream sm:pb-0" data-id="element-0" data-mp="5gez9t0lqvv">
      <noscript data-id="element-1" data-mp="2zlv32jnmchps">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="2zmemk4sx3e5x" />
      </noscript>
      <PromoBar data-id="element-3" data-mp="38nuodo5o27yj" />
      <Hero data-id="element-4" data-mp="3dkuufz2inapn" />
      <SocialProofBar data-id="element-5" data-mp="3dkl6eh117dml" />
      <QuickTestimonials data-id="element-6" data-mp="3dlw6a5rcw18f" />
      <Problems data-id="element-7" data-mp="3dm5ylzzvikha" />
      <SystemOverview data-id="element-8" data-mp="3dirxsw6uyjby" />
      <TheoryPractice data-id="element-9" data-mp="nvsub5qlapwh" />
      <Volumes data-id="element-10" data-mp="nwc582htoe10" />
      <FitCheck data-id="element-11" data-mp="nur7y544igzg" />
      <Bonuses data-id="element-12" data-mp="nvaszup2llhp" />
      <LaunchUrgency data-id="element-13" data-mp="nxwvvh10nctl" />
      <Offer data-id="element-14" data-mp="sudnwmbc6bby" />
      <TestimonialWall data-id="element-15" data-mp="stuclog6yl6w" />
      <Guarantee data-id="element-16" data-mp="st2heeqiaph5" />
      <FormatNotice data-id="element-17" data-mp="swqchiblnjxz" />
      <Faqs data-id="element-18" data-mp="36hx792iaw2a" />
      <Comparison data-id="element-19" data-mp="3688dot76uy6" />
      <FinalCall data-id="element-20" data-mp="35ovwnmbgyrj" />
      <ClosingWords data-id="element-21" data-mp="356wxj89s6fx" />
      <Contact data-id="element-22" data-mp="38kxqn1ac7l9" />
      <SiteFooter data-id="element-23" data-mp="3uct3pkqacp10" />
      <StickyBuyBar data-id="element-24" data-mp="3udawu8hnin4p" />
    </div>;
}